import React from "react";
import "./SectorsSection.css";

const CorporatePestControlTrustSection = () => {
const sectors = [
  "Corporate Offices",
  "IT Parks",
  "Warehouses",
  "Industrial Units",
  "Food Processing Units",
  "Hotels & Restaurants",
  "Hospitals",
  "Schools & Colleges",
  "Residential Societies (Common Areas)",
  "Shopping Malls",
  "Logistics Centers",
  "Pharmaceutical Units"
];


  return (
    <section className="sector-section-wrapper">
      <div className="sector-section-container">
        <h2 className="sector-section-title">Trusted Across Sectors</h2>
        <p className="sector-section-subtitle">
          Serving diverse industries with excellence
        </p>

        <div className="sector-tags-wrapper">
          {sectors.map((sector, index) => (
            <span key={index} className="sector-tag">
              {sector}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorporatePestControlTrustSection;
